export default __webpack_public_path__ + "static/media/paycard-extra.d5568bd7.png";